import Styles from "@/components/PromoBanner/index.module.scss";
import Link from "next/link";

const PromoBanner = ({ promoBannerData = {} }) => {
  const {
    items: [
      { fields: { label = "", promoText = "", url = "" } = {} } = {},
    ] = [],
  } = promoBannerData;
  return (
    <div className={Styles.promoBanner}>
      <div className="banner-container">
        <div className="banner-description">
          <span>{promoText}</span>
          <div className="banner-link">
            <Link href={url}>{label}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
